export default function wrapInParen(str = "", { pad = "" } = {}) {
  return str && `${pad}(${str})`;
}
